// Mobile Grid Toggle Web Component
class MobileGridToggle extends HTMLElement {
  connectedCallback() {
    this.holder = this.parentElement;
    this.initializeGridToggle();
  }

  injectCss() {
    if (!document.getElementById('two-col-style')) {
      const style = document.createElement('style');
      style.id = 'two-col-style';
      style.textContent = `
        .product-item__wishlist {
          top: 20px !important;
        }

        .product-item__properties-tags {
          position: absolute;
          top: 1rem;
          left: 0.5rem;
          z-index: 5;
          display: flex;
          flex-direction: column;
          gap: 4px;
          transition: transform .25s cubic-bezier(0,0,.58,1);
        }

        .product-item:has(.swym-button) .product-item__preview-tags {
          right: 0.5rem;
        }

        .product-grid[data-mobile-columns="2"] .product-item__preview-tag,
        .product-grid[data-mobile-columns="2"] .product-item__properties-tag {
          font-size: .5rem;
        }
      `;
      document.head.appendChild(style);
    }
  }

  removeCss() {
    const style = document.getElementById('two-col-style');
    if (style) style.remove();
  }

  setGridColumns(columns, productGrid, toggleButtons) {
    // Update active state
    toggleButtons.forEach((btn) => {
      btn.classList.remove('mobile-grid-toggle__button--active');
      if (btn.dataset.columns === columns) {
        btn.classList.add('mobile-grid-toggle__button--active');
      }
    });

    // Apply grid layout via data attribute
    if (productGrid) {
      productGrid.setAttribute('data-mobile-columns', columns);
    }

    // Inject CSS only if mobile + 2 columns
    if (window.innerWidth <= 768 && columns === '2') {
      this.injectCss();
    } else {
      this.removeCss();
    }
  }

  initializeGridToggle() {
    const productGrid = this.holder && this.holder.querySelector('.product-grid');
    const toggleButtons = this.querySelectorAll('.mobile-grid-toggle__button');
    const savedColumns = localStorage.getItem('mobile-grid-columns') || '2';

    if (!productGrid) return;

    if (productGrid.classList.contains('product-grid--loading')) {
      return;
    }

    // Set default if not already set
    if (!localStorage.getItem('mobile-grid-columns')) {
      localStorage.setItem('mobile-grid-columns', '2');
    }

    toggleButtons.forEach((btn) => {
      const { columns } = btn.dataset;
      btn.classList.remove('mobile-grid-toggle__button--active');

      if (columns === savedColumns) {
        btn.classList.add('mobile-grid-toggle__button--active');
      }

      btn.addEventListener('click', () => {
        this.handleToggleClick(btn, toggleButtons, productGrid, columns);
      });
    });

    productGrid.setAttribute('data-mobile-columns', savedColumns);

    const preloadStyle = document.getElementById('grid-preload');
    if (preloadStyle) {
      preloadStyle.remove();
    }

    productGrid.style.display = '';
  }

  handleToggleClick(clickedBtn, allButtons, productGrid, columns) {
    allButtons.forEach((button) => {
      button.classList.remove('mobile-grid-toggle__button--active');
    });

    clickedBtn.classList.add('mobile-grid-toggle__button--active');

    productGrid.setAttribute('data-mobile-columns', columns);
    localStorage.setItem('mobile-grid-columns', columns);

    // Re-check on resize (mobile ↔ desktop bascule)
    window.addEventListener('resize', () => {
      const currentColumns = productGrid.getAttribute('data-mobile-columns') || '2';
      this.setGridColumns(currentColumns, productGrid, allButtons);
    });
  }
}

if (!customElements.get('mobile-grid-toggle')) {
  customElements.define('mobile-grid-toggle', MobileGridToggle);
}
